import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import {SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';

export function setSelection(data: SelectionRestoreData): void {
  // Merge in the changes into the open protocol, client-side.
  AppDispatcher.dispatch({
    actionType: EventConstants.SELECTION_SET,
    data,
  });
}
